const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  // DOMAIN SERVER MỚI
  development: {
    api: "https://sisp-api.cgis.asia/",
    media_url: "https://sisp-api.cgis.asia/",
    domainAdminSide: "http://localhost:3000",
    domainUserSide: "http://localhost:3000",
    domainName: "",
    workSpace: "sisp",
    wmsBaseLink: "https://geo3.cgis.asia/geoserver/wms/",
    datastore: 'sisp',
    gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
    // wmsBaseLink: "https://geoserver.phutho.gov.vn/geoserver/gwc/service/wms/",
  },
    production: {
      api: "https://sisp-api.cgis.asia/",
      media_url: "https://sisp-api.cgis.asia/",
      domainAdminSide: "https://admin.sisp.cgis.asia",
      domainUserSide: "https://sisp.cgis.asia",
      domainName: "sisp.cgis.asia",
      workSpace: "sisp",
      wmsBaseLink: "https://geo3.cgis.asia/geoserver/wms/",
      datastore: 'sisp',
      gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
      // wmsBaseLink: "https://geo3.cgis.asia/geoserver/gwc/service/wms/",
  }
};

module.exports = apiEnvironment[env];